import { render, staticRenderFns } from "./AutoFollowUps.vue?vue&type=template&id=099970c8&scoped=true"
import script from "./AutoFollowUps.vue?vue&type=script&lang=js"
export * from "./AutoFollowUps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099970c8",
  null
  
)

export default component.exports